import { supabase } from '../lib/supabase';

export const accountService = {
  async getAll() {
    try {
      const { data, error } = await supabase?.from('accounts')?.select('*')?.order('created_at', { ascending: false });
      
      if (error) throw error;
      
      return data?.map(row => ({
        id: row?.id,
        userId: row?.user_id,
        name: row?.name,
        type: row?.type,
        group: row?.account_group,
        balance: parseFloat(row?.balance),
        currency: row?.currency,
        creditLimit: row?.credit_limit ? parseFloat(row?.credit_limit) : null,
        principalAmount: row?.principal_amount ? parseFloat(row?.principal_amount) : null,
        startDate: row?.start_date,
        loanTerm: row?.loan_term,
        createdAt: row?.created_at,
        updatedAt: row?.updated_at
      }));
    } catch (error) {
      console.error('Error fetching accounts:', error);
      throw error;
    }
  },

  async getById(accountId) {
    try {
      const { data, error } = await supabase?.from('accounts')?.select('*')?.eq('id', accountId)?.single();
      
      if (error) throw error;
      
      return {
        id: data?.id,
        userId: data?.user_id,
        name: data?.name,
        type: data?.type,
        group: data?.account_group,
        balance: parseFloat(data?.balance),
        currency: data?.currency,
        creditLimit: data?.credit_limit ? parseFloat(data?.credit_limit) : null,
        principalAmount: data?.principal_amount ? parseFloat(data?.principal_amount) : null,
        startDate: data?.start_date,
        loanTerm: data?.loan_term,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error fetching account:', error);
      throw error;
    }
  },

  async create(accountData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('accounts')?.insert({
          user_id: user?.id,
          name: accountData?.name,
          type: accountData?.type,
          account_group: accountData?.group,
          balance: accountData?.balance || 0,
          currency: 'BBD',
          credit_limit: accountData?.creditLimit || null,
          principal_amount: accountData?.principalAmount || null,
          start_date: accountData?.startDate || null,
          loan_term: accountData?.loanTerm || null
        })?.select()?.single();
      
      if (error) throw error;
      
      return {
        id: data?.id,
        userId: data?.user_id,
        name: data?.name,
        type: data?.type,
        group: data?.account_group,
        balance: parseFloat(data?.balance),
        currency: data?.currency,
        creditLimit: data?.credit_limit ? parseFloat(data?.credit_limit) : null,
        principalAmount: data?.principal_amount ? parseFloat(data?.principal_amount) : null,
        startDate: data?.start_date,
        loanTerm: data?.loan_term,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  },

  async update(accountId, updates) {
    try {
      const updateData = {};
      if (updates?.name !== undefined) updateData.name = updates?.name;
      if (updates?.type !== undefined) updateData.type = updates?.type;
      if (updates?.group !== undefined) updateData.account_group = updates?.group;
      if (updates?.balance !== undefined) updateData.balance = updates?.balance;
      if (updates?.currency !== undefined) updateData.currency = updates?.currency;
      if (updates?.creditLimit !== undefined) updateData.credit_limit = updates?.creditLimit;
      if (updates?.principalAmount !== undefined) updateData.principal_amount = updates?.principalAmount;
      if (updates?.startDate !== undefined) updateData.start_date = updates?.startDate;
      if (updates?.loanTerm !== undefined) updateData.loan_term = updates?.loanTerm;

      const { data, error } = await supabase?.from('accounts')?.update(updateData)?.eq('id', accountId)?.select()?.single();
      
      if (error) throw error;
      
      return {
        id: data?.id,
        userId: data?.user_id,
        name: data?.name,
        type: data?.type,
        group: data?.account_group,
        balance: parseFloat(data?.balance),
        currency: data?.currency,
        creditLimit: data?.credit_limit ? parseFloat(data?.credit_limit) : null,
        principalAmount: data?.principal_amount ? parseFloat(data?.principal_amount) : null,
        startDate: data?.start_date,
        loanTerm: data?.loan_term,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error updating account:', error);
      throw error;
    }
  },

  async delete(accountId) {
    try {
      const { error } = await supabase?.from('accounts')?.delete()?.eq('id', accountId);
      
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting account:', error);
      throw error;
    }
  }
};